import { lt, showSuccessAlert } from '@mews/framework';
import { useRepositoryMutation } from '@mews-commander/data-access';
import { BookerFormValues } from './types';

export const useUpdateBookerMutation = (reservationIds: Array<string>) =>
    useRepositoryMutation('reservations', 'updateBooker', {
        transformParams: ({ customerId }: BookerFormValues) => ({
            reservationIds,
            customerId,
        }),
        invalidateQueries: { routingRules: ['getDetailsOnReservationUpdate'] },
        onSuccess: () => showSuccessAlert({ description: lt('BookerChangedSuccessMessage') }),
    });
